import * as am5 from "@amcharts/amcharts5";
import * as am5percent from "@amcharts/amcharts5/percent";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import chartModel from "../../../models/charts/chart.model";
import 'CssFolder/chart.scss';
import languageModel from "../../../models/language.model";

export default function TasksStatusDonutChartComponent() {

  let chart;
  let chartId = 'piechart';
  let root;
  let series;
  let legend;
  let totalLabel;
  let modal;

  function noDataEventHandler() {
    modal = am5.Modal.new(root, {
      content: languageModel.getText("LT00000281", "The chart has no data")
    });

    series.events.on("datavalidated", function(e) {
      var _series = e.target;

      if (e.target.data.length < 1) {
        // Show modal
        modal.open();
      } else {
        // Hide modal
        modal.close();
      }

    })
  }

  function initChart(chartData) {
    createChart();
    createSeries();
    loadData(chartData.visitResponse);
    setTotalLabel(chartData.scheduleTypeResponse);
    // No data event
    noDataEventHandler();
    // createLegend();
    // Animate on when appear
    series.appear(1000, 100);

  }

  function createChart() {
    root?.dispose(); // dispose any pre-existing roots
    root = am5.Root.new(chartId);

    // Formatter
    root.numberFormatter.set("numberFormat", "#,###");

    // Themes
    root.setThemes([
      am5themes_Animated.new(root)
    ]);

    // Chart settings
    chart = root.container.children.push(
      am5percent.PieChart.new(root, {
        radius: am5.percent(75),
        innerRadius: am5.percent(65),
        layout: root.verticalLayout,
      })
    );

    // Chart title
    chart.children.unshift(
      am5.Label.new(root, {
        text: "Store Visit Status",
        fontSize: 16,
        fontWeight: "500",
        textAlign: "center",
        x: am5.percent(50),
        centerX: am5.percent(50),
        paddingTop: 0,
        paddingBottom: 0
      })
    );
  }

  function createSeries() {
    series = chart.series.push(am5percent.PieSeries.new(root, {
      alignLabels: true,
      valueField: "count",
      categoryField: "visitStatusName",
      tooltip: am5.Tooltip.new(root, {
        labelText: "{visitStatusName}: {count}"
      })
    }));

    series.get("colors").set("colors", [
      am5.color(0x84E0BE),
      am5.color(0xF9AC19),
      am5.color(0xF38068)
    ]);

    series.labels.template.setAll({
      fontSize: 10,
      radius: 0,
      centerX: 0,
      centerY: 0,
      text: "{visitStatusName}: [bold]{valuePercentTotal.formatNumber('0.0')}%[/] ({count})"
    });

    series.ticks.template.setAll({
      location: 0.95,
    });

    // Add label
    totalLabel = root.tooltipContainer.children.push(am5.Label.new(root, {
      x: am5.percent(50),
      y: am5.percent(53),
      centerX: am5.p50,
      centerY: am5.p50,
      fill: am5.color(0x000000),
      fontSize: 16,
      textAlign: "center"
    }));
  }

  function loadData(visitResponse) {
    series.data.setAll(visitResponse);
  }

  function setTotalLabel(scheduleTypeResponse) {
    let plannedTotal = 0;
    let unplannedTotal = 0;
    // Calculate total
    scheduleTypeResponse.forEach(e => {
      if (e.scheduleTypeCode === '001') {
        plannedTotal += e.count;
      } else if (e.scheduleTypeCode === '002') {
        unplannedTotal += e.count;
      }
    });

    totalLabel.set("text", "Planned: [bold]" + plannedTotal + "[/]\n[fontSize: 12px]Unplanned: [bold]" + unplannedTotal + "[/][/]");
  }

  // function createLegend() {
  //   legend = chart.children.push(am5.Legend.new(root, {
  //     centerX: am5.p50,
  //     x: am5.p50,
  //     marginTop: 0,
  //     marginBottom: 0
  //   }));

  //   legend.labels.template.setAll({
  //       fontSize: 12,
  //       fontWeight: "300"
  //   });

  //   legend.data.setAll(series.dataItems);
  // }

  return {
    oninit: function (vnode) {
      chartId += chartModel.generateID();
    },
    oncreate: function (vnode) {
      if (vnode.attrs.data) {
        initChart(vnode.attrs.data);
      }
    },
    view: function (vnode) {
      return m('.chart', {
        id: chartId
      });
    }
  }
}